import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=3a73efa2"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a73efa2')) {
      api.createRecord('3a73efa2', component.options)
    } else {
      api.reload('3a73efa2', component.options)
    }
    module.hot.accept("./EditPassword.vue?vue&type=template&id=3a73efa2", function () {
      api.rerender('3a73efa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/pages/EditPassword.vue"
export default component.exports